import { render } from "./AddNetworkOffering.vue?vue&type=template&id=5bd6f28a&scoped=true"
import script from "./AddNetworkOffering.vue?vue&type=script&lang=js"
export * from "./AddNetworkOffering.vue?vue&type=script&lang=js"

import "./AddNetworkOffering.vue?vue&type=style&index=0&id=5bd6f28a&scoped=true&lang=scss"

import exportComponent from "/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd6f28a"]])

export default __exports__